import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitoratnagiricab() {



  const cardData = {
    keyword: " Mumbai to Ratnagiri Cab",


"headingDescription": "Royal Route Cab offers reliable Mumbai to Ratnagiri cab service, providing safe, comfortable, and affordable coastal travel for families, couples, tourists, and group journeys. Ratnagiri is a beautiful coastal district in the Konkan region of Maharashtra, located approximately 330–350 km from Mumbai, known for its beaches, forts, seafood, and lush green landscapes. Our professional drivers ensure a smooth and scenic journey through the Konkan highway with safe driving, timely pickup, and comfortable travel experience. We offer flexible options including one-way drops, round trips, Konkan sightseeing packages, and customized itineraries. Our fleet includes economy sedans, premium sedans, SUVs, Innova, Ertiga, Innova Crysta, and Tempo Travellers suitable for all group sizes. With transparent pricing, 24/7 availability, and easy booking, Royal Route Cab is your trusted choice for Mumbai to Ratnagiri cab service.",

"topPlaces": [
  {
    "title": "Ganpatipule Beach",
    "description": "Ganpatipule Beach is one of the most famous beaches in the Konkan region, known for its clean white sand, clear waters, and peaceful environment. It is also home to the sacred Swayambhu Ganpati Temple, making it a perfect blend of spirituality and natural beauty for travelers coming from Mumbai."
  },
  {
    "title": "Ratnadurg Fort",
    "description": "Ratnadurg Fort is a historic sea fort overlooking the Arabian Sea, offering panoramic coastal views. It is known for its ancient architecture, lighthouse, and scenic surroundings, making it a popular heritage and photography spot in Ratnagiri."
  },
  {
    "title": "Thibaw Palace",
    "description": "Thibaw Palace is a historical palace built for the exiled king of Burma. It showcases colonial-era architecture and serves as a museum preserving regional history and royal heritage, attracting history lovers and tourists."
  },
  {
    "title": "Mandavi Beach",
    "description": "Mandavi Beach is a calm and less crowded beach near Ratnagiri city, ideal for sunset views, relaxation, and peaceful walks. It offers a serene coastal experience away from city noise."
  },
  {
    "title": "Jaigad Fort",
    "description": "Jaigad Fort is a coastal fort located at the meeting point of the Shastri River and Arabian Sea. It is known for its strategic location, lighthouse, and stunning sea views, making it a must-visit historical site."
  },
  {
    "title": "Pawas Village",
    "description": "Pawas is a spiritual village near Ratnagiri known for Swami Swaroopanand Ashram. It is a peaceful destination for meditation, devotion, and spiritual retreats surrounded by natural beauty."
  },
  {
    "title": "Bhatye Beach",
    "description": "Bhatye Beach is a scenic beach near Ratnagiri city known for its long coastline, coconut trees, and calm atmosphere. It is perfect for family outings and evening relaxation."
  },
  {
    "title": "Marleshwar Waterfall Temple",
    "description": "Marleshwar is a unique cave temple dedicated to Lord Shiva located near a waterfall. It is a combination of spirituality and natural beauty, making it a popular monsoon destination for travelers from Mumbai."
  },
  {
    "title": "Jaigad Lighthouse",
    "description": "Jaigad Lighthouse offers breathtaking views of the Arabian Sea and surrounding landscapes. It is an important navigation point and a popular tourist attraction for coastal sightseeing."
  },
  {
    "title": "Ratnagiri Mango Farms",
    "description": "Ratnagiri is world-famous for Alphonso mangoes. The mango farms in the region attract tourists during season, offering fresh produce, orchard visits, and a unique agricultural experience."
  }
],






services: [
  {
    name: "Mumbai to Ratnagiri Cab",
    description: "Mumbai to Ratnagiri cab service offers a scenic and comfortable journey to the beautiful Konkan coast. Ideal for families, tourists, and weekend travelers, this service ensures smooth travel through highways and ghats. Professional drivers and well-maintained vehicles enhance safety. It guarantees a relaxing and enjoyable travel experience."
  },
  {
    name: "Mumbai to Ratnagiri Taxi",
    description: "Mumbai to Ratnagiri taxi provides private and convenient transportation for long-distance travel. This service includes door-to-door pickup and flexible travel schedules. Comfortable vehicles ensure a pleasant journey. It guarantees a hassle-free experience."
  },
  {
    name: "Mumbai to Ratnagiri Cab Service",
    description: "Mumbai to Ratnagiri cab service offers professional travel solutions with multiple vehicle options. This service is ideal for beach vacations, family trips, and group tours. Clean vehicles and trained drivers ensure comfort. It ensures a smooth journey."
  },
  {
    name: "Mumbai to Ratnagiri Taxi Service",
    description: "Mumbai to Ratnagiri taxi service ensures dependable transportation with comfortable seating and experienced chauffeurs. This service is ideal for long-distance coastal travel. Flexible booking options enhance convenience. It guarantees a safe journey."
  },
  {
    name: "Cab from Mumbai to Ratnagiri",
    description: "Cab from Mumbai to Ratnagiri offers a convenient way to travel between cities with complete comfort. This service is ideal for those who prefer scenic road trips. Professional drivers ensure safe journeys. It ensures a relaxed experience."
  },
  {
    name: "Taxi from Mumbai to Ratnagiri",
    description: "Taxi from Mumbai to Ratnagiri provides reliable long-distance travel for individuals and groups. This service ensures smooth travel through coastal routes with experienced drivers. Comfortable seating enhances the journey. It guarantees a dependable ride."
  },
  {
    name: "Mumbai to Ratnagiri Cab Booking",
    description: "Mumbai to Ratnagiri cab booking allows customers to reserve their ride easily with flexible options. Travelers can choose vehicle type, pickup location, and timing. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Mumbai to Ratnagiri Taxi Booking Online",
    description: "Mumbai to Ratnagiri taxi booking online provides a quick and convenient way to plan your trip. Customers can compare vehicles and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Mumbai to Ratnagiri Cab Price",
    description: "Mumbai to Ratnagiri cab price varies based on vehicle type, distance, and trip duration. Transparent pricing ensures no hidden charges. Customers can choose from budget and premium options. It helps in planning travel expenses efficiently."
  },
  {
    name: "Mumbai to Ratnagiri Taxi Fare",
    description: "Mumbai to Ratnagiri taxi fare is designed to be competitive for long-distance travel. Fare depends on route and vehicle selection. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Ratnagiri One Way Cab",
    description: "Mumbai to Ratnagiri one way cab offers cost-effective travel without return charges. This service is ideal for single-side journeys. Flexible pickup options enhance convenience. It ensures smooth and economical travel."
  },
  {
    name: "Mumbai to Ratnagiri Round Trip Taxi",
    description: "Mumbai to Ratnagiri round trip taxi provides complete travel solutions including return journeys. This service is ideal for vacations and Konkan tours. Flexible schedules and comfortable vehicles enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "Mumbai to Ratnagiri Innova Cab",
    description: "Mumbai to Ratnagiri Innova cab is perfect for families and groups seeking spacious and comfortable travel. Premium seating and smooth performance enhance long journeys. It ensures a comfortable coastal travel experience."
  },
  {
    name: "Mumbai to Ratnagiri Ertiga Cab",
    description: "Mumbai to Ratnagiri Ertiga cab offers affordable and spacious travel for small groups and families. Comfortable seating and good mileage make it ideal for long-distance journeys. It ensures a pleasant trip."
  },
  {
    name: "Mumbai to Ratnagiri Sedan Cab",
    description: "Mumbai to Ratnagiri sedan cab is ideal for individuals and couples seeking economical travel. Sedans offer smooth rides and comfort for long journeys. Professional drivers ensure safety. It ensures a relaxed trip."
  },
  {
    name: "Mumbai to Ratnagiri SUV Taxi",
    description: "Mumbai to Ratnagiri SUV taxi provides spacious and comfortable travel for groups. SUVs offer better performance on ghat roads and extra luggage space. Suitable for long-distance journeys. It ensures a comfortable experience."
  },
  {
    name: "Cheap Mumbai to Ratnagiri Cab",
    description: "Cheap Mumbai to Ratnagiri cab offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Transparent pricing ensures no hidden charges. It ensures economical travel."
  },
  {
    name: "Best Mumbai to Ratnagiri Taxi Service",
    description: "Best Mumbai to Ratnagiri taxi service ensures top-quality vehicles, professional drivers, and excellent customer support. This service focuses on comfort, safety, and punctuality. It guarantees a reliable and premium journey."
  }
],

tableData: [
  ["Mumbai to Ratnagiri Cab", "Mumbai to Ratnagiri Taxi"],
  ["Mumbai to Ratnagiri Cab Service", "Mumbai to Ratnagiri Taxi Service"],
  ["Cab from Mumbai to Ratnagiri", "Taxi from Mumbai to Ratnagiri"],
  ["Mumbai to Ratnagiri Cab Booking", "Mumbai to Ratnagiri Taxi Booking Online"],
  ["Mumbai to Ratnagiri Cab Price", "Mumbai to Ratnagiri Taxi Fare"],
  ["Mumbai to Ratnagiri One Way Cab", "Mumbai to Ratnagiri Round Trip Taxi"],
  ["Mumbai to Ratnagiri Innova Cab", "Mumbai to Ratnagiri Ertiga Cab"],
  ["Mumbai to Ratnagiri Sedan Cab", "Mumbai to Ratnagiri SUV Taxi"],
  ["Cheap Mumbai to Ratnagiri Cab", "Best Mumbai to Ratnagiri Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Ratnagiri Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and scenic Mumbai to Ratnagiri cab service, perfect for coastal trips, family vacations, and Konkan tours."
  },
  {
    WhyChooseheading: "Experienced Konkan Route Drivers",
    WhyChoosedescription: "Our drivers are well-trained in handling Konkan and ghat routes, ensuring safe driving and smooth travel through hilly roads."
  },
  {
    WhyChooseheading: "Ideal for Beach & Konkan Tours",
    WhyChoosedescription: "Ratnagiri is famous for beaches, forts, and Alphonso mangoes, and our cab service is perfect for relaxing Konkan trips."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all travel costs with no hidden charges."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day Konkan travel packages."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Ratnagiri cab service operates 24/7, allowing flexible departure anytime as per your plan."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for group travel."
  },
  {
    WhyChooseheading: "Trusted Konkan Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Ratnagiri cab bookings due to reliable service and experienced drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Ratnagiri cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Ratnagiri for one-way and round trips." },
  { question: "What is the distance between Mumbai and Ratnagiri?", answer: "The distance is approximately 330 to 350 km and takes around 7 to 9 hours depending on route and traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Ratnagiri cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Is this suitable for Konkan trips?", answer: "Yes, our service is ideal for Konkan tours, family trips, and beach travel." },
  { question: "Do you provide ghat route experienced drivers?", answer: "Yes, our drivers are experienced in Konkan and ghat routes." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for weekends and holiday travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Santosh Kadam",
    feedback: "The Mumbai to Ratnagiri journey with Royal Route Cabs was very smooth and enjoyable. The coastal drive was comfortable and the service was reliable throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aarti Deshmukh",
    feedback: "Excellent experience traveling from Mumbai to Ratnagiri. The cab was clean, the driver was polite, and the entire trip felt safe and well-managed.",
    rating: 5
  }
];









  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ratnagiri Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-ratnagiri-cab.jpg", // replace if needed
  "description": "Book Mumbai to Ratnagiri cab service with Royal Route Cabs for safe, reliable, and comfortable Konkan travel. Available for one-way and round-trip journeys with sedan, SUV, Innova, and Ertiga vehicles. 24x7 outstation taxi service at affordable rates.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9999", // approx starting fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-ratnagiri-cab"
  }
};





  return (
    <div>
<Helmet>
  <title>Mumbai to Ratnagiri Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Ratnagiri cab with Royal Route Cabs. Safe and affordable Konkan travel taxi service with sedan, SUV, Innova & Ertiga cars. 24x7 reliable outstation rides."
  />

  <meta
    name="keywords"
    content="mumbai to ratnagiri cab, mumbai to ratnagiri taxi, mumbai to ratnagiri cab service, mumbai to ratnagiri taxi service, cab from mumbai to ratnagiri, taxi from mumbai to ratnagiri, mumbai to ratnagiri cab booking, mumbai to ratnagiri taxi booking online, mumbai to ratnagiri cab price, mumbai to ratnagiri taxi fare, mumbai to ratnagiri one way cab, mumbai to ratnagiri round trip taxi, mumbai to ratnagiri innova cab, mumbai to ratnagiri ertiga cab, mumbai to ratnagiri sedan cab, mumbai to ratnagiri suv taxi, cheap mumbai to ratnagiri cab, best mumbai to ratnagiri taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/61.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoratnagiricab;